import { Segmented } from 'antd';
import { useNavigate } from 'react-router-dom';

import {
  LEADS_VIEW_MODE_OPTIONS,
  LEADS_VIEW_MODE_PATHS,
} from '../data/constants';

import type { FC } from 'react';

import './LeadsViewModeSwitcher.scss';

export type LeadsViewMode = 'registry' | 'funnels';

interface LeadsViewModeSwitcherProps {
  value: LeadsViewMode;
}

export const LeadsViewModeSwitcher: FC<LeadsViewModeSwitcherProps> = ({
  value,
}) => {
  const navigate = useNavigate();

  const modeChangeHandler = (nextValue: LeadsViewMode) => {
    if (nextValue === value) return;

    navigate(LEADS_VIEW_MODE_PATHS[nextValue]);
  };

  return (
    // Размер как у остальных контролов шапки (28px): переключатель страниц не
    // должен выделяться габаритом — акцент держится заливкой активного пункта.
    <Segmented<LeadsViewMode>
      className="LeadsViewModeSwitcher"
      options={LEADS_VIEW_MODE_OPTIONS}
      value={value}
      onChange={modeChangeHandler}
    />
  );
};
